import { useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { Controller, useForm } from 'react-hook-form'
import ReCAPTCHA from 'react-google-recaptcha'
import { Box, Button, TextField } from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'

import { getGoogleRecaptchaToken, isSandbox } from 'service/env'
import { routes } from 'Routes'
import * as service from 'service'
import schemas from '../../schemas'

export const Form = () => {
  const [loading, setLoading] = useState(false)
  const [recaptcha, setRecaptcha] = useState(undefined)

  const recaptchaRef = useRef(null)

  const disableSubmitButton = !isSandbox ? !recaptcha || loading : false

  const history = useHistory()
  const snackbar = useSnackbar()

  const { control, handleSubmit, errors } = useForm({
    validationSchema: schemas.forgotPassword,
    defaultValues: {
      email: '',
      password: '',
    },
  })

  const onSubmit = async (data) => {
    if (disableSubmitButton) return

    setLoading(true)

    try {
      const response = await service.dponet.auth.forgotPassword({
        ...data,
        recaptcha,
      })

      snackbar.open({
        message: response.data.message,
        variant: 'success',
      })
      history.push(routes.root)
    } catch (error) {
      if (!isSandbox) resetRecaptcha()
      snackbar.open({
        message: defineErrorMessage(error),
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  const resetRecaptcha = () => {
    recaptchaRef.current.reset()
    setRecaptcha(undefined)
  }

  const defineErrorMessage = (error) => {
    const response = error?.response
    const status = response?.status
    const error_message = response.data?.error?.message

    if ((status === 404 || status === 422) && error_message)
      return error_message

    return 'Ocorreu algum erro! Tente novamente!'
  }

  const handleAcceptedRecaptcha = (recaptchaToken) => {
    setRecaptcha(recaptchaToken)
  }
  const disableRecaptcha = () => setRecaptcha(undefined)

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Controller
        as={
          <TextField
            label="E-mail"
            color="primary"
            variant="outlined"
            error={!!errors.email}
            helperText={errors && errors.email && errors.email.message}
            fullWidth
          />
        }
        control={control}
        name="email"
        mode="onChange"
      />
      {!isSandbox && (
        <Box mt={2} display="flex" alignItems="center" justifyContent="center">
          <ReCAPTCHA
            ref={recaptchaRef}
            render="explicit"
            sitekey={getGoogleRecaptchaToken()}
            onChange={handleAcceptedRecaptcha}
            onExpired={disableRecaptcha}
          />
        </Box>
      )}
      <Box
        mt={2}
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
      >
        <Button
          color="primary"
          type="submit"
          variant="contained"
          disabled={disableSubmitButton}
        >
          {loading ? 'Enviando...' : 'Recuperar'}
        </Button>
      </Box>
    </form>
  )
}

export default Form
